export default __webpack_public_path__ + "static/media/Low-cost.0ec6c886.webp";